import { supabase, Venta } from './supabase';

export interface VentaDetalleItem {
  id: string;
  nombre: string;
  codigo: string;
  cantidad: number;
  precioUnitario: number;
  subtotal: number;
}

const PAGE_SIZE = 1000;

/** Recupera TODAS las ventas, recorriendo las páginas necesarias (no se limita a 100). */
export const cargarTodosLosVentas = async (): Promise<Venta[]> => {
  const todas: Venta[] = [];
  let from = 0;

  for (;;) {
    const { data, error } = await supabase
      .from('ventas')
      .select('*')
      .order('fecha', { ascending: false })
      .range(from, from + PAGE_SIZE - 1);

    if (error) throw error;
    if (!data || data.length === 0) break;

    todas.push(...data);

    if (data.length < PAGE_SIZE) break;
    from += PAGE_SIZE;
  }

  return todas;
};

/** Mapa id de usuario -> nombre, para mostrar el empleado responsable. */
export const cargarMapaUsuarios = async (): Promise<Record<string, string>> => {
  const { data } = await supabase.from('usuarios').select('id, nombre');
  const map: Record<string, string> = {};
  (data || []).forEach((u) => {
    map[u.id] = u.nombre;
  });
  return map;
};

/** Recupera el detalle real de una venta con los datos de cada producto. */
export const cargarDetalleVenta = async (ventaId: string): Promise<VentaDetalleItem[]> => {
  const { data: detalles, error } = await supabase
    .from('detalle_ventas')
    .select('*')
    .eq('venta_id', ventaId);

  if (error) throw error;
  if (!detalles || detalles.length === 0) return [];

  const ids = Array.from(new Set(detalles.map((d) => d.producto_id)));

  const { data: productos } = await supabase
    .from('productos')
    .select('id, nombre, codigo_interno')
    .in('id', ids);

  const map = new Map((productos || []).map((p) => [p.id, p]));

  return detalles.map((d) => {
    const prod = map.get(d.producto_id);
    return {
      id: d.id,
      nombre: prod?.nombre || 'Producto',
      codigo: prod?.codigo_interno || '',
      cantidad: Number(d.cantidad) || 0,
      precioUnitario: Number(d.precio_unitario) || 0,
      subtotal: Number(d.subtotal) || 0,
    };
  });
};